import EsusView from 'components/esus/EsusView'

export default function ProcessamentoView() {
  return <EsusView url='/pec/user/relatorios/administracao/processamento' />
}
